import { practicesLocationsGroupedOptions, practicesOptions } from "../../../../../lib/systemData";
import CustomSelectGroupedMultiple from "../../../../common/interactive/CustomSelectGroupedMultiple";
import CustomSelectMultiple from "../../../../common/interactive/CustomSelectMultiple";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { filterActions } from "../../../../../store/filter";
import { removeStorageItem } from "../../../../../lib/script";
import Button from "../../../../common/Button";
import { workqueueActions } from "../../../../../store/workqueue";
import { setFiltersInLocalStorage } from "../../../../../lib/filters";

export default function MissedApptsFUFilters({ workQ }) {
    const dispatch = useDispatch();
    const [filtersValues, setFiltersValues] = useState(null);

    function mainSelectAction(value) {
        let updateobject = {
            ...filtersValues,
        };
        let update = JSON.parse(JSON.stringify(updateobject));

        if (value?.data?.value?.constructor == Array) {
            update[value.identifier.type] = value.data.value;
        } else {
            update[value.identifier.type] = value.data.value;
        }

        setFiltersValues(update);
    }

    async function setFiltersHandler() {
        dispatch(filterActions.setFiltersMultiple(filtersValues));
        dispatch(workqueueActions.setRefreshApi());

        setFiltersInLocalStorage(filtersValues, workQ?.slug);
    }

    function clearAllFiltersHandler() {
        dispatch(filterActions.setFiltersMultiple({}));
        dispatch(workqueueActions.setRefreshApi());

        setFiltersValues(null);
        removeStorageItem(workQ?.slug);
    }

    return (
        <>
            <CustomSelectMultiple
                label={"Practice"}
                optionsData={practicesOptions()}
                preSelectedValue={filtersValues?.practice}
                action={mainSelectAction}
                name={"practice"}
                identifier={{ type: "practice" }}
            />
            <CustomSelectGroupedMultiple
                label={"Clinic"}
                optionsData={practicesLocationsGroupedOptions()}
                preSelectedValue={filtersValues?.location}
                action={mainSelectAction}
                name={"location"}
                identifier={{ type: "location" }}
            />
            <Button click={clearAllFiltersHandler} btnStyle={"btn_white"}>
                Clear All Filters
            </Button>
            <Button click={setFiltersHandler}>Set Filters</Button>
        </>
    );
}
